<template>
    <section class="main-section main-section--platform">
        <div class="ct">
            <h3 class="tit"><span>플랫폼 이용 방법</span></h3>
            <ul class="platform">
                <li v-for="platform in platforms" :key="platform.subtit" class="platform__list">
                    <div class="platform__box">
                        <div class="platform__icon">
                            <img :src="platform.icon" alt="" />
                        </div>
                        <p class="subtit">{{ platform.subtit }}</p>
                        <p class="txt">{{ platform.txt }}</p>
                        <a class="btn" :href="platform.link">자세히 보기</a>
                    </div>
                </li>
            </ul>

        </div>
    </section>
</template>

<script>
export default {
    data(){
        return{
            platforms:[
                {
                    icon: "/images/main/platform-icon4.png",
                    subtit: "셀러 이용 메뉴얼",
                    txt: "Seller's manual",
                    link: "/center/notice/61519db92d408003adb4f716",
                },
                {
                    icon: "/images/main/platform-icon5.png",
                    subtit: "바이어 이용 메뉴얼",
                    txt: "Buyer's manual",
                    link: "/center/notice/61519eaa2d408003adb4f950",
                },

                // {
                //     icon: '/images/main/platform-icon1.png',
                //     subtit: '계정 정보 확인 방법',
                //     txt: 'How to verify account information',
                //     link: '',
                // },
                // {
                //     icon: '/images/main/platform-icon2.png',
                //     subtit: '계정 초기화 방법',
                //     txt: 'How to verify account information',
                //     link: '',
                // },
                // {
                //     icon: '/images/main/platform-icon3.png',
                //     subtit: '매칭상담회 이용 방법',
                //     txt: 'How to Initialize an account',
                //     link: '',
                // }
            ]
        }
    },
};
</script>
<style lang="scss" scoped>
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";

.platform{
    display: flex; margin: -10px; font-size: 16px; color: #fff;
    list-style: none;
    .subtit { margin: 30px 0 10px; line-height: 1; font-size: 30px; }
    .txt { opacity: .3; }
    .btn { display: inline-block; margin-top: 60px; padding: 10px 30px 12px; line-height: 0.8; text-align: center; font-weight: 700; color: inherit; border: 2px solid #ffffff; border-radius: 50px; }
    &__list { flex: 1 1; padding: 10px; }
    &__box { padding: 40px 30px; background: #495666; border-radius: 15px; }
    &__icon img { display: block; }
}
@media(max-width:1200px){
    .platform{
        font-size: 15px;
        .subtit { margin: 30px 0 10px; line-height: 1; font-size: 24px; }
        .btn { margin-top: 50px; padding: 10px 30px 12px; }
        &__icon img { width: 70px; height: auto; }
    }
}
@media(max-width:768px){
    .platform{
        flex-direction: column; font-size: 14px;
        .subtit { margin: 20px 0 5px; line-height: 1; font-size: 20px; }
        .btn { margin-top: 25px; width: 100%; }
        &__list { padding: 5px 10px; }
        &__box { padding: 24px 26px; }
        &__icon img { width: 60px; height: auto; }
    }
}
</style>